<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="100px" >
					<el-row>
						<el-col :span="12">
							<el-form-item label="开票公司名" prop="sellname"><el-input v-model="formParameter.sellname" autocomplete="off" placeholder="有就填"></el-input></el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="税号" prop="sellnum"><el-input v-model="formParameter.sellnum" autocomplete="off" placeholder="有就填"></el-input></el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="客户姓名" prop="name"><el-input :disabled="true" v-model="formParameter.name"  autocomplete="off" placeholder="张三">	</el-input></el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="合计金额" prop="cost"><el-input :disabled="true" v-model="formParameter.cost" autocomplete="off" placeholder="7000"></el-input></el-form-item>
						</el-col>
					</el-row>
					<el-row>
						
						<el-col :span="24">
							<el-form-item label="项目名" prop="sname"><el-input :disabled="true" v-model="formParameter.sname" autocomplete="off"></el-input></el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="开票时间" prop="kpdate">
								<el-date-picker
								value-format="yyyy-MM-dd"
    						  	v-model="formParameter.kpdate"
    						  	type="date"
    						  	placeholder="选择日期">
    							</el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="邮箱地址" prop="fpemail"><el-input v-model="formParameter.fpemail" autocomplete="off"></el-input></el-form-item>
						</el-col>
					</el-row>
						<el-row>
						<el-col :span="24">
							<el-form-item label="发票" prop="fppic"><el-image :src="baseURI+formParameter.fppic" autocomplete="off"></el-image></el-form-item>
						</el-col>
					</el-row>
			</el-form>
		</div>
		<div slot="footer">
			<!-- <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">提交</el-button> -->
			<!-- <el-button @click="confirm1()">审批不合格</el-button> -->
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/xueli/fapiao.js';
import imageUpload from '@/components/biz/imageUpload/imageUpload.vue';
import constant from '@/util/constant.js';

export default {
	name: 'edit',
	components: {
			popup,
			imageUpload
		},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			baseURI:constant.serverUrl,
			parameter: {},
			formParameter: {},
			pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },
        value1: '',
        value2: '',
        value3: '',
		};
	},
	methods: {
			//打开弹框
			open(parameter, title, disabled, size) {
				this.parameter = parameter;
				this.disabled = disabled;
				this.$refs.popup.open(title, size);
				this.$nextTick(() => {
					this.init();
				})
			},
			//关闭弹框
			close() {
				this.disabled = false;
				this.$refs.popup.close();
			},
			//提交表单
			confirm() {
				this.$utils.checkForm(this.$refs.form, () => {
					this.confirmLoading = true;
					if (!this.parameter.id) {
						//添加
						let parameter = this.$utils.merger(this.formParameter);
						api.save(parameter,
							response => {
								this.$utils.msg.success(response.msg);
								this.confirmLoading = false;
								this.close();
								this.$parent.list();
							},
							response => {
								this.$utils.msg.warning(response.msg);
								this.confirmLoading = false;
							}
						);
					} else {
						//编辑
						let parameter = this.$utils.merger(this.formParameter);
						api.update(parameter,
							response => {
								this.$utils.msg.success(response.msg);
								this.confirmLoading = false;
								this.close();
								this.$parent.list();
							},
							response => {
								this.$utils.msg.warning(response.msg);
								this.confirmLoading = false;
							}
						);
					}
				});
			},
			// 审批不合格
			confirm1(){
						let parameter = this.$utils.merger(this.formParameter);
						api.update1(parameter,
							response => {
								this.$utils.msg.success(response.msg);
								this.confirmLoading = false;
								this.close();
								this.$parent.list();
							},
							response => {
								this.$utils.msg.warning(response.msg);
								this.confirmLoading = false;
							}
						);
			},
			init() {
				this.popupLoading = true;
				//清除等待
				this.confirmLoading = false;
				//清空内容
				this.formParameter = {};
				//清楚校验
				this.$refs.form.clearValidate();
				
				if (this.parameter.id) {
					//编辑查询数据
					let parameter = {
						id: this.parameter.id
					};
					api.toUpdate(parameter, response => {
						this.formParameter = response.data;
						this.popupLoading = false;
					});
				} else {
					//添加
					this.popupLoading = false;
				}
			}
		}
	};
</script>

<style lang="scss" scoped="scoped">
	@import '~common/custom/css/common.scss';
	@import '~common/custom/css/popup/popup.scss';
</style>
